import Cookies from 'js-cookie';

const getItem = (key) => {
  const data = Cookies.get(key);

  try {
    return JSON.parse(data);
  } catch (err) {
    return data;
  }
};

const setItem = (key, value) => {
  const stringify = typeof value !== 'string' ? JSON.stringify(value) : value;
  return Cookies.set(key, stringify);
};

const removeItem = (key) => {
  Cookies.remove(key);
};

const setItemBase64 = (key, value) => {
  const bkey = btoa(key);
  const encoded = btoa(JSON.stringify(value));
  Cookies.set(bkey, encoded);
};

const getItemBase64 = (key, defaultValue = null) => {
  const bkey = btoa(key);
  const stored = Cookies.get(bkey);
  if (!stored) return defaultValue;
  try {
    return JSON.parse(atob(stored));
  } catch (err) {
    return defaultValue;
  }
};

const removeItemBase64 = (key) => {
  const bkey = btoa(key);
  Cookies.remove(bkey);
};

export { getItem, setItem, removeItem, setItemBase64, getItemBase64, removeItemBase64 };
